import { render, staticRenderFns } from "./OverviewTip.vue?vue&type=template&id=48df76d8&scoped=true"
var script = {}
import style0 from "./OverviewTip.vue?vue&type=style&index=0&id=48df76d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48df76d8",
  null
  
)

export default component.exports